import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=4c2702d6&scoped=true"
import script from "./Qrcode.vue?vue&type=script&lang=js"
export * from "./Qrcode.vue?vue&type=script&lang=js"
import style0 from "./Qrcode.vue?vue&type=style&index=0&id=4c2702d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2702d6",
  null
  
)

export default component.exports